import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad40",
  style: {"width":"400px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "header_title centered" }, "変更", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_AttendeeForm = _resolveComponent("AttendeeForm")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "AttendeeEditModal",
    "content-class": "ofs modalContent shadowContent rad10 modalNormal"
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_AttendeeForm, {
          class: "centered",
          currentMember: _ctx.currentMember,
          action: _ctx.action,
          type: `horizontal`,
          onUpdate: _ctx.editAttendee
        }, null, 8, ["currentMember", "action", "onUpdate"])
      ])
    ]),
    _: 1
  }))
}